<div fxLayout="column">
    <h2 fxFlex="0 0 auto" mat-dialog-title>Account Balance Adjustment</h2>
    <mat-dialog-content fxFlex="auto">
        <form #correctionForm="ngForm" class="correction-form">
            <div fxLayout="column" fxLayoutGap="20px">
                <div fxFlex="auto" fxLayout="row">
                    <mat-form-field fxFlex="1 1 10%">
                        <input matInput placeholder="Currency" type="text" disabled value="{{data.correction.currency}}" name="currency">
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 60%">
                        <input matInput placeholder="Account" type="text" disabled value="{{data.correction.account}}" name="account">
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 30%">
                        <mat-select required [ngClass]="'desk'" placeholder="Desk" floatPlaceholder="always" [(ngModel)]="data.correction.desk" name="desk">
                            <mat-option *ngFor="let desk of desks" [value]="desk">
                                {{ desk }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex="auto" fxLayout="row">
                    <mat-form-field fxFlex="1 1 auto">
                        <input matInput placeholder="Expected Balance" type="text" disabled value="{{data.correction.balanceCorrectionCalculatedAmount | number:'1.2-2'}}"
                            name="expectedBalance">
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 auto">
                        <input matInput placeholder="Statement Balance" type="text" disabled value="{{data.correction.balanceCorrectionOfficialAmount | number:'1.2-2'}}"
                            name="statementBalance">
                    </mat-form-field>
                    <mat-form-field fxFlex="1 1 auto">
                        <input matInput placeholder="Adjustment Amount" type="text" disabled value="{{data.correction.amount | number:'1.2-2'}}"
                            name="adjustmentAmount">
                    </mat-form-field>
                </div>
                <div fxLayout="row">
                    <mat-form-field fxFlex="auto">
                        <input matInput placeholder="Reason" required [(ngModel)]="data.correction.changeReason" name="changeReason">
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <div fxFlexFill>
        <span> </span>
    </div>

    <mat-dialog-actions fxFlex="0 0 auto" align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button color="primary" [disabled]="!correctionForm.form.valid" (click)="submit()" [mat-dialog-close]="submitResult">Submit</button>
    </mat-dialog-actions>

</div>